import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withMeta as higherOrder } from '../../extenders';
function withMeta(key, value) {
    return higherOrder(key, value)(this);
}
AnalyticsDispatcher.prototype.withMeta = withMeta;
//# sourceMappingURL=withMeta.js.map